import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Hub } from 'aws-amplify';
import { User } from '../../_models/user.model';
import { AuthenticationService } from '../../core/services/authentication.service';
import { WebSocketService } from '../../core/services/web-socket.service';
import { CrisisAlertService } from '../../shared/services/crisis-alert.service';
import { Constants } from '../../shared/constants';
import { SessionManagementService } from '../../core/services/session-management.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-authenticated-user',
  templateUrl: './authenticated-user.component.html',
  styleUrls: ['./authenticated-user.component.scss']
})
export class AuthenticatedUserComponent implements OnInit {

  constructor(private authenticationService: AuthenticationService,
    private webSocketService: WebSocketService,
    private route: ActivatedRoute,
    private crisisAlertService: CrisisAlertService,
    private sessionManagementService: SessionManagementService,
    private router: Router) {
  }

  ngOnInit() {
    // spinner page
    console.log('Spinner started on page.');
    Hub.listen('auth', (data) => {
      switch (data.payload.event) {
        case 'signIn':
          console.log('User has been authenticated!');
          this.authenticationService.createIdentity().subscribe((currentUser: User) => {
            if (currentUser) {
              this.webSocketService.connect().subscribe(message => {
                if (message.action === Constants.CONNECT) {
                  console.log('WebSocket: next(): ' + JSON.stringify(message));
                  currentUser.currentSessionId = message.connectionId;
                  // Save User Login Session
                  this.authenticationService.saveLoginSession(currentUser).subscribe(user => {
                    console.log('Spinner cleared on page.');
                    console.log('User = ' + user);
                    // Logout the previous session, if any
                    if (user.previousSessionId) {
                      console.log('Disconnect the Previous Session ' + user.previousSessionId);
                      this.webSocketService.send({ 'action': 'signout', 'connectionId': user.previousSessionId });
                    }
                    // Initiallize Session Timeout Alert
                    this.sessionManagementService.configure(user,
                      { 'timeOut': environment.user.sessionExpiryMinutes,
                        'warnAt': environment.user.sessionExpiryWarningMinutes });
                    // Load reference data
                    this.crisisAlertService.loadRefDataFirstTime(user);
                    // Navigate
                    this.router.navigate(['/cases']);
                  }, err => {
                    console.log('Error Saving Login Session' + err);
                    this.authenticationService.logout(Constants.LogoutReason_LOGOUT);
                  });
                } else {
                  this.sessionManagementService.checkSessionExpiration();
                  console.log('Heartbeat : ' + message.action);
                }
              }, error => {
                // Called whenever there is an err
                console.log('WebSocket: error() ' + JSON.stringify(error));
                this.authenticationService.logout(Constants.LogoutReason_NEW_SESSION);
              }, () => {
                // Called when connection is closed (for whatever reason)
                console.log('WebSocket: complete()');
                console.log('Connection closed!');
                this.authenticationService.logout(Constants.LogoutReason_NEW_SESSION);
              });
            } else {
              console.log('User is not authenticated.');
              this.authenticationService.logout(Constants.LogoutReason_LOGOUT);
            }
          }, error => {
            console.log('Error in setting up user identity in SP', error);
            this.authenticationService.logout(Constants.LogoutReason_LOGOUT);
          });
          break;
        case 'signUp':
          break;
        case 'signOut':
          console.log('User has been Signed Out!');
          break;
        case 'signIn_failure':
          break;
        case 'configured':
          break;
      }
    });
  }

}
